import React from 'react';

interface GenerateMeasurementRusProps {
    fill?: string;
}

export const GenerateMeasurementRus = ({ fill = 'currentColor' }: GenerateMeasurementRusProps) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M4.49055 11.2728L7.45652 5.75H9.44707V14.5H7.45652V8.98317L4.49055 14.5H2.5V5.75H4.49055V11.2728Z"
            fill={fill}
        />
        <path
            d="M12.5439 11.2725L15.5098 5.75H17.5V14.5H15.5098V8.9834L12.5439 14.5H10.5527V5.75H12.5439V11.2725Z"
            fill={fill}
        />
    </svg>
);
